import { isNotNullOrUndefined } from "../../utils/helpers/stringHelper";

export const getArrears = (account) => isNotNullOrUndefined(account.arrearsValue) && account.arrearsValue > 0;